'use client'

import { useRouter } from 'src/lib/router'
import { useCallback } from 'react'
import { Key } from 'react-stately'

import { Tabs } from './tabs'

interface RouterTabsProps {
  paramName: string
  defaultValue?: string
  variant?: 'pills' | 'underline' | 'bordered'
  distribution?: 'auto' | 'equal'
  className?: string
  children: React.ReactNode
  'aria-label'?: string
}

export const RouterTabs: React.FC<RouterTabsProps> = ({
  paramName,
  defaultValue,
  children,
  ...tabsProps
}) => {
  const router = useRouter()
  const selectedKey = (router.query[paramName] as string) || defaultValue

  const onSelectionChange = useCallback(
    (key: Key) => {
      router.push(
        {
          pathname: router.pathname,
          query: { ...router.query, [paramName]: String(key) }
        },
        undefined,
        { shallow: true }
      )
    },
    [paramName, router]
  )

  return (
    <Tabs
      {...tabsProps}
      selectedKey={selectedKey}
      onSelectionChange={onSelectionChange}>
      {children}
    </Tabs>
  )
}
